import { Button } from "@faire/slate/components/button";
import {
  BaseModal,
  BaseModalBody,
  BaseModalFooter,
  BaseModalHeader,
} from "@faire/slate/components/modal/base";
import type { ReactNode } from "react";

const FOI_IMAGE_URL =
  "https://cdn.faire.com/fastly/8a44e00e47baf257074c3806e7064c8460ab2bf8d62d2a8e35262ff08d5ee727.jpeg";

interface ControlOfferModalProps {
  open: boolean;
  onClose: () => void;
  onStartShopping: () => void;
}

export const ControlOfferModal = ({
  open,
  onClose,
  onStartShopping,
}: ControlOfferModalProps): ReactNode => (
  <BaseModal open={open} onClose={onClose} size="small">
    <BaseModalHeader title="You’ve got 50% off your first order" />
    <BaseModalBody>
      <div className="flex flex-col gap-(--slate-spacing-element-large)">
        <img
          alt=""
          className="aspect-[16/9] w-full rounded-(--slate-radius-container-default) object-cover"
          src={FOI_IMAGE_URL}
        />
        <p className="type-fs-paragraph text-fs-text-primary">
          Welcome to Faire. Enjoy up to $100 off when you order from as many
          brands as you’d like.
        </p>
        <p className="type-fs-label text-fs-text-subdued">
          Offer expires August 12, 2026 at 11:59 PM EDT.
        </p>
      </div>
    </BaseModalBody>
    <BaseModalFooter>
      <Button onClick={onStartShopping}>Start shopping</Button>
      <Button variant="plain" onClick={onClose}>
        Maybe later
      </Button>
    </BaseModalFooter>
  </BaseModal>
);
